export function chatLevel() {

    $('.growtype-chat-level-bar-ajax').each(function () {
        let chatForm = $('.g-chatform');
        let sessionToken = chatForm.attr('data-session-token');

        if (!sessionToken) {
            return;
        }

        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: {
                action: 'growtype_chat_render_chat_level_bar',
                token: sessionToken,
                nonce: growtype_chat_ajax.nonce,
            }, success: function (response) {
                if (response['data']['content']) {
                    $('.growtype-chat-level-bar-ajax').replaceWith(response['data']['content'])
                }
                if (response['data']['modal_content']) {
                    $('.g-chat-level-explanation').html(response['data']['modal_content']);
                }
            }
        });
    });

    document.addEventListener('growtypeChatMessageResponseEvent', function (event) {
        // Mood change logic
        const moodChanged = event.detail?.response?.data?.mood_changed ?? false;
        const assistantMood = event.detail?.response?.data?.assistant_mood ?? '';

        if (moodChanged && assistantMood) {
            const moodLabels = growtype_chat_ajax.available_moods || {};
            const moodLabel = moodLabels[assistantMood] || assistantMood.charAt(0).toUpperCase() + assistantMood.slice(1);
            showMoodBubble($('.g-chatform')[0], moodLabel);

            // Update settings modal if it exists
            const moodSelect = $('select[name="assistant_mood"]');
            if (moodSelect.length > 0) {
                moodSelect.val(assistantMood).trigger('chosen:updated');
            }
        }
    });

    // Listen for typing animation completion to show XP bubble
    document.addEventListener('typingAnimationComplete', function (event) {
        const messageData = event.detail?.messageData;
        const messageElement = event.detail?.message;
        const messageIndex = event.detail?.messageIndex ?? 0;

        // Check for total response XP first for a consolidated bubble on the first message
        const totalXp = event.detail?.response?.data?.total_user_xp_added ?? 0;
        let xpAdded = messageData?.user_xp_added ?? 0;

        // Fallback to data attribute (often used for intro/pre-rendered messages)
        if (!xpAdded && messageElement) {
            xpAdded = parseInt(messageElement.getAttribute('data-xp-added')) || 0;
        }

        // Only show XP bubble if we have XP
        if (xpAdded > 0 && messageElement) {

            // Show XP bubble
            setTimeout(() => {
                showXpBubble(messageElement, xpAdded);
            }, 1000);

            // Update the level bar
            const levelContainer = document.querySelector('.g-chat-level');
            if (levelContainer) {
                let targetPercentage = event.detail?.response?.data?.user_xp_percentage;
                let targetTitle = event.detail?.response?.data?.user_xp_title;
                const currentXp = parseInt(levelContainer.getAttribute('data-current-xp')) || 0;
                let baseXp = parseInt(levelContainer.getAttribute('data-base-xp')) || 0;

                // Force baseXp to 0 for guest users to ensure progress starts from 0%
                if (typeof growtype_chat_ajax !== 'undefined' && !growtype_chat_ajax.is_logged_in) {
                    baseXp = 0;
                }

                const nextXp = parseInt(levelContainer.getAttribute('data-next-xp')) || (baseXp + 1000);

                // Fallback to JS calculation if backend didn't provide it (e.g. guest or pre-rendered message)
                if ((targetPercentage === undefined || targetPercentage === null) && xpAdded > 0) {
                    if (nextXp > baseXp) {
                        targetPercentage = Math.round(((xpAdded - baseXp) / (nextXp - baseXp)) * 100);
                        targetPercentage = Math.max(0, Math.min(100, targetPercentage));
                    }
                }

                // Check if we are using the initial target percentage from the attribute
                let isInitialTarget = false;
                if (targetPercentage === undefined || targetPercentage === null) {
                    const attrTarget = levelContainer.getAttribute('data-target-percentage');
                    if (attrTarget !== null) {
                        targetPercentage = attrTarget;
                        isInitialTarget = true;
                    }
                }

                targetTitle = targetTitle ?? '';
                const progressBar = levelContainer.querySelector('.g-chat-level-bar-inner');
                const progressBarDetails = levelContainer.querySelector('.g-chat-level-details');
                const $progressBarDetails = $(progressBarDetails);

                if (targetPercentage !== null && targetPercentage !== undefined && progressBar) {
                    setTimeout(() => {
                        if ($progressBarDetails.length > 0 && targetTitle) {
                            $progressBarDetails.replaceWith(targetTitle);
                        }

                        // Update modal content if present
                        const modalContent = event.detail?.response?.data?.modal_chat_level_content;
                        if (modalContent) {
                            $('.g-chat-level-explanation').html(modalContent);
                        }

                        // ── Virtue Compass Update ─────────────────────────────
                        // Dispatch AFTER HTML update so the listener finds the new elements
                        const virtueUpdate = event.detail?.response?.data?.virtue_update || event.detail?.response?.data?.response_messages?.[0]?.metadata?.virtue_update;
                        if (virtueUpdate && virtueUpdate.scores) {
                            const virtueEvent = new CustomEvent('thVirtueUpdate', {
                                detail: {
                                    scores: virtueUpdate.scores,
                                    evaluation: virtueUpdate
                                }
                            });
                            document.dispatchEvent(virtueEvent);
                        }
                        // ──────────────────────────────────────────────────────

                        progressBar.style.setProperty('--progress-section-width', `${targetPercentage}%`);
                        progressBar.classList.add('anim-pulse');

                        setTimeout(() => {
                            progressBar.classList.remove('anim-pulse');
                        }, 3000);

                        levelContainer.removeAttribute('data-target-percentage');
                        levelContainer.removeAttribute('data-target-title');

                        // Update current state for next calculation
                        // Only add xpAdded if it wasn't already included in the initial backend state
                        if (!isInitialTarget) {
                            levelContainer.setAttribute('data-current-xp', xpAdded);

                            // Save to cookie if user is not logged in
                            if (typeof growtype_chat_ajax !== 'undefined' && !growtype_chat_ajax.is_logged_in) {
                                const sessionId = levelContainer.getAttribute('data-session-id');
                                if (sessionId) {
                                    setCookie(`chat_${sessionId}_xp_points`, xpAdded, 30);
                                }
                            }
                        } else {
                            levelContainer.setAttribute('data-target-percentage', targetPercentage);
                        }
                    }, 2500);
                }
            }
        }

        // Listen for manual content rendering (e.g. after unlock) to show XP bubble
        $(document).on('growtypeChatContentRendered', function (event, detail) {
            const xpAdded = detail?.xp_added || 0;
            if (xpAdded > 0) {
                const $newContent = $(detail.content);
                const messageId = $newContent.attr('data-id');
                if (messageId) {
                    const messageElement = document.querySelector(`.g-chatform-message[data-id="${messageId}"]`);
                    if (messageElement) {
                        setTimeout(() => {
                            showXpBubble(messageElement, xpAdded);
                        }, 1500);

                        // Re-calculate level bar if we have the level container
                        const levelContainer = document.querySelector('.g-chat-level');
                        if (levelContainer) {
                            const currentXpAttr = parseInt(levelContainer.getAttribute('data-current-xp')) || 0;
                            const newXp = currentXpAttr + xpAdded;
                            levelContainer.setAttribute('data-current-xp', newXp);

                            const baseXp = parseInt(levelContainer.getAttribute('data-base-xp')) || 0;
                            const nextXp = parseInt(levelContainer.getAttribute('data-next-xp')) || (baseXp + 1000);

                            if (nextXp > baseXp) {
                                const newPercentage = Math.round(((newXp - baseXp) / (nextXp - baseXp)) * 100);
                                const progressBar = levelContainer.querySelector('.g-chat-level-bar-inner');
                                if (progressBar) {
                                    setTimeout(() => {
                                        progressBar.style.setProperty('--progress-section-width', `${newPercentage}%`);
                                        progressBar.classList.add('anim-pulse');
                                        setTimeout(() => progressBar.classList.remove('anim-pulse'), 3000);
                                    }, 2500);
                                }
                            }
                        }
                    }
                }
            }
        });

        // Special Effects
        let specialEffects = messageData?.special_effects;
        if (!specialEffects && messageElement) {
            specialEffects = messageElement.getAttribute('data-special-effects');
        }

        if (specialEffects && messageElement) {
            setTimeout(() => {
                showSpecialEffectsBubble(messageElement, specialEffects);
            }, xpAdded > 0 ? 3000 : 1000); // Shift if XP bubble is shown
        }
    });

    /**
     * Cookie helpers
     */
    function getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    function eraseCookie(name) {
        document.cookie = name + '=; Max-Age=-99999999; path=/;';
    }

    /**
     * Creates and shows a bubbling Mood animation
     * @param {HTMLElement} container - The container element to append the bubble to
     * @param {string} moodLabel - The mood label to display
     */
    function showMoodBubble(container, moodLabel) {
        const bubble = document.createElement('div');
        bubble.className = 'g-chat-mood-bubble'; // Reusing XP bubble styles with a modifier
        bubble.innerHTML = `<span class="mood-icon">🎭</span><span class="mood-label">${moodLabel}</span>`;

        container.appendChild(bubble);

        requestAnimationFrame(() => {
            bubble.classList.add('is-animating');
        });

        setTimeout(() => {
            bubble.remove();
        }, 3000);
    }

    /**
     * Creates and shows a bubbling XP animation
     * @param {HTMLElement} container - The container element to append the bubble to
     * @param {number} xpAmount - The amount of XP to display
     */
    function showXpBubble(container, xpAmount) {
        // Ensure container has relative positioning for absolute children
        const originalPosition = container.style.position;
        container.style.position = 'relative';

        // Array of vibrant colors for variety
        const colors = [
            '#FFD700', // Gold
            '#FF6B6B', // Coral Red
            '#4ECDC4', // Turquoise
            '#95E1D3', // Mint Green
            '#F38181', // Pink
            '#AA96DA', // Purple
            '#FCBAD3', // Light Pink
            '#A8E6CF', // Pastel Green
            '#FF8B94', // Salmon
            '#FFA07A', // Light Salmon
            '#87CEEB', // Sky Blue
            '#FFB6C1', // Light Pink
        ];

        // Pick a random color
        const randomColor = colors[Math.floor(Math.random() * colors.length)];

        // Create the bubble element
        const bubble = document.createElement('div');
        bubble.className = 'g-chat-xp-bubble';
        bubble.innerHTML = `<span class="xp-icon">✨</span><span class="xp-amount">+${xpAmount} XP</span>`;

        // Apply random color
        bubble.style.setProperty('--xp-bubble-color', randomColor);

        container.appendChild(bubble);

        // Trigger the animation after a brief delay (for CSS transition to work)
        requestAnimationFrame(() => {
            bubble.classList.add('is-animating');
        });

        setTimeout(() => {
            bubble.remove();

            // Restore original position if needed
            container.style.position = originalPosition;
        }, 2000);
    }

    /**
     * Creates and shows a bubbling Special Effects animation with multiple icons
     * @param {HTMLElement} container - The container element to append the bubble to
     * @param {string} effectType - The type of effect to display
     */
    function showSpecialEffectsBubble(container, effectType) {
        // Ensure container has relative positioning for absolute children
        const originalPosition = container.style.position;
        if (container.style.position !== 'relative') {
            container.style.position = 'relative';
        }

        let icon = '✨';
        let label = effectType.charAt(0).toUpperCase() + effectType.slice(1);
        let background = 'linear-gradient(135deg, #ff4d4d, #f9cb28)';
        let shadowColor = 'rgba(255, 77, 77, 0.5)';

        switch (effectType) {
            case 'hearts':
                icon = '❤️';
                label = 'Sweet!';
                background = 'linear-gradient(135deg, #ff4d4d, #f9cb28)';
                shadowColor = 'rgba(255, 77, 77, 0.5)';
                break;
            case 'spicy':
                icon = '🔥';
                label = 'Hot!';
                background = 'linear-gradient(135deg, #ff8c00, #ff0080)';
                shadowColor = 'rgba(255, 0, 128, 0.5)';
                break;
        }

        // Show multiple icons (8 to 10)
        const count = 8 + Math.floor(Math.random() * 3);

        for (let i = 0; i < count; i++) {
            setTimeout(() => {
                const bubble = document.createElement('div');
                bubble.className = 'g-chat-effect-bubble';
                bubble.style.background = background;
                bubble.style.boxShadow = `0 4px 15px ${shadowColor}, 0 0 20px rgba(255, 255, 255, 0.2)`;

                // Randomize horizontal offset and scale via CSS variables
                const offsetX = (Math.random() - 0.5) * 150; // -75px to 75px
                const scale = 0.6 + Math.random() * 0.7; // 0.6 to 1.3

                bubble.style.setProperty('--effect-x', `${offsetX}px`);
                bubble.style.setProperty('--effect-scale', scale);

                if (i === 0) {
                    // Only the first one gets the label
                    bubble.innerHTML = `<span class="effect-icon">${icon}</span><span class="effect-label">${label}</span>`;
                    bubble.style.zIndex = '102'; // Keep labeled one on top
                } else {
                    bubble.innerHTML = `<span class="effect-icon">${icon}</span>`;
                    bubble.style.padding = '6px 12px';
                    bubble.style.minWidth = 'initial';
                }

                container.appendChild(bubble);

                // Trigger animation
                requestAnimationFrame(() => {
                    bubble.classList.add('is-animating');
                });

                // Cleanup
                setTimeout(() => {
                    bubble.remove();
                    // Restore position if no more bubbles exist
                    if (container.querySelectorAll('.g-chat-effect-bubble').length === 0) {
                        container.style.position = originalPosition;
                    }
                }, 2800);
            }, i * 120); // Staggered start every 120ms
        }
    }
}
